import { gql } from '@apollo/client';

export const FETCH_COUPONS = gql`
    query FetchCoupons {
        FetchCoupons {
            data {
                coupons {
                    code
                    updated_at
                    generation_type
                    redeemed_at
                    redeemed
                    created_at
                    id
                    membership_duration_id
                    user_id
                    receiver_detail
                }
            }
            error {
                message
                code
                field
            }
        }
    }
`;


